import { Injectable } from '@angular/core';
import { AccordionVM } from '../accordion/accordion.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class ArtiService {

  constructor(private httpClient: HttpClient) { }

  public get(atype: ArtiType): Observable<AccordionVM[]>
  {
    return this.httpClient.get<AccordionVM[]>(Constants.arti + atype);
  }
}

export enum ArtiType
{
  abhanga,
  arti,
  bhajan,
  ovi,
  prarthana,
}
